import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/pages/SearchPage/index.js";
const variants = import.meta.webpackContext("/pages/SearchPage", { recursive: true, regExp: /\.\/__variants__\/plp\-grid\-expansion\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });